import { Theme } from 'theme-ui';
import { TGetColorStateDefinition } from './types';
import tinycolor from 'tinycolor2';

const components: (
  theme: Theme,
) => Record<string, Record<string, string | TGetColorStateDefinition>> = (
  theme: Theme,
) => {
  const palette = theme.palette;

  return {
    accordion: {
      panels: {
        backgroundColor: palette.background.paper,
        color: palette.text.primary,
        borderColor: palette.border.ghost,
      },
    },
    datagrid: {
      borderColor: palette.background.default,
      header: {
        backgroundColor: palette.background.default,
        color: palette.text.primary,
        borderColor: palette.background.default,
      },
      body: {
        preventParse: true,
        backgroundColor: palette.background.paper,
        evenRowsBackgroundColor: palette.darkenColor(
          palette.background.paper,
          3,
        ),
        color: palette.text.primary,
        borderColor: palette.gray['800'],

        selectedRows: {
          borderColor: palette.gray['800'],
          backgroundColor: palette.getOneState(
            { backgroundColor: palette.background.paper },
            'selected',
          ).backgroundColor,
          color: palette.getContrastText(
            palette.getOneState(
              { backgroundColor: palette.background.paper },
              'selected',
            ).backgroundColor as string,
          ),
        },
      },
    },
    paginationPrimary: {
      backgroundColor: palette.primary.main,
      icons: {
        backgroundColor: palette.primary.main,
        borderColor: palette.primary.main,
        color: palette.primary.contrastText,
      },
      pagesBox: {
        preventParse: true,
        backgroundColor: palette.background.paper,
        borderColor: palette.border.field,
        color: palette.text.primary,
      },
    },
    paginationSecondary: {
      backgroundColor: palette.background.default,
      icons: {
        backgroundColor: palette.background.default,
        borderColor: palette.background.default,
        color: palette.text.primary,
      },
      pagesBox: {
        preventParse: true,
        backgroundColor: palette.background.paper,
        borderColor: palette.border.field,
        color: palette.text.primary,
      },
    },
    paginationDatagrid: {
      backgroundColor: palette.background.default,
      icons: {
        backgroundColor: palette.background.default,
        borderColor: palette.background.default,
        color: palette.text.primary,
      },
      pagesBox: {
        preventParse: true,
        backgroundColor: palette.background.paper,
        borderColor: palette.border.field,
        color: palette.text.primary,
      },
    },
    primaryTable: {
      borderColor: palette.background.paper,
      header: {
        backgroundColor: palette.primary.main,
        color: palette.text.secondary,
        borderColor: palette.primary.main,
      },
      body: {
        preventParse: true,
        backgroundColor: palette.background.paper,
        evenRowsBackgroundColor: palette.darkenColor(
          palette.background.paper,
          3,
        ),
        color: palette.text.primary,
        borderColor: palette.gray['800'],
        selectedRows: {
          borderColor: palette.gray['800'],
          backgroundColor: palette.getOneState(
            { backgroundColor: palette.background.paper },
            'selected',
          ).backgroundColor,
          color: palette.getContrastText(
            palette.getOneState(
              { backgroundColor: palette.background.paper },
              'selected',
            ).backgroundColor as string,
          ),
        },
      },
    },
    cleanTable: {
      borderColor: palette.background.paper,
      header: {
        backgroundColor: palette.background.paper,
        color: palette.text.primary,
        borderColor: palette.primary.main,
      },
      body: {
        preventParse: true,

        backgroundColor: palette.background.paper,
        borderColor: palette.border.ghost,
        color: palette.text.primary,

        evenRowsBackgroundColor: palette.background.paper,
        additionalInfoButton: {
          backgroundColor: palette.secondary.light,
          color: '#4e4e4e',
          borderColor: 'transparent',
        },
        selectedRows: {
          borderColor: palette.gray['800'],
          backgroundColor: palette.getOneState(
            { backgroundColor: palette.background.paper },
            'selected',
          ).backgroundColor,
          color: palette.getContrastText(
            palette.getOneState(
              { backgroundColor: palette.background.paper },
              'selected',
            ).backgroundColor as string,
          ),
        },
      },
    },
    secondaryTable: {
      borderColor: palette.background.paper,
      header: {
        backgroundColor: palette.darkenColor(palette.background.default, 2),
        color: palette.text.primary,
        borderColor: palette.background.default,
      },
      body: {
        preventParse: true,
        backgroundColor: palette.background.paper,
        evenRowsBackgroundColor: palette.darkenColor(
          palette.background.paper,
          2,
        ),
        color: palette.text.primary,
        borderColor: palette.darkenColor(palette.background.paper, 5),

        selectedRows: {
          borderColor: palette.darkenColor(palette.background.paper, 5),
          backgroundColor: palette.getOneState(
            { backgroundColor: palette.background.paper },
            'selected',
          ).backgroundColor,
          color: palette.getContrastText(
            palette.getOneState(
              { backgroundColor: palette.background.paper },
              'selected',
            ).backgroundColor as string,
          ),
        },
      },
    },
    /**
     * Paneles de dashboards
     */
    panel: {
      header: {
        color: '', //components.panel.header.color
        backgroundColor: '',
        borderColor: '',
      },
      content: {
        color: '',
        backgroundColor: '',
        borderColor: '',
      },
      footer: {
        color: '',
        backgroundColor: '',
        borderColor: '',
      },
    },
    desktop: {
      windowHeader: tinycolor(theme.palette.primary.main)
        .setAlpha(0.8)
        .toRgbString(),
    },
  };
};

export default components;
